export default "__VITE_ASSET__yKkOZ$pG__"